import React, { useEffect, useRef } from "react";

const ZohoWidget = () => {
    const containerRef = useRef(null);
    const isInitialized = useRef(false);

    useEffect(() => {
        if (isInitialized.current) return;

        // Load the CSS
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://static.zohocdn.com/recruit/embed_careers_site/css/v1.1/embed_jobs.css';
        link.type = 'text/css';

        // Only add if not already present
        if (!document.querySelector('link[href*="embed_jobs.css"]')) {
            document.head.appendChild(link);
        }

        // Load and execute the JavaScript
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://static.zohocdn.com/recruit/embed_careers_site/javascript/v1.1/embed_jobs.js';

        script.onload = () => {
            setTimeout(() => {
                if (window.rec_embed_js && !isInitialized.current) {
                    try {
                        window.rec_embed_js.load({
                            widget_id: "rec_job_listing_div",
                            page_name: "Career4",
                            source: "CareerSite",
                            site: "https://career.coschool.ai",
                            brand_color: "#6875E2",
                            empty_job_msg: "No current Openings"
                        });
                        isInitialized.current = true;

                        // Prevent automatic scrolling by the widget
                        setTimeout(() => {
                            const jobsDiv = document.getElementById('rec_job_listing_div');
                            if (jobsDiv) {
                                // Override any scroll behavior
                                jobsDiv.style.scrollBehavior = 'auto';

                                // Listen for clicks and prevent unwanted scrolling
                                jobsDiv.addEventListener('click', (e) => {
                                    // Don't prevent the click, just ensure we stay in view
                                    setTimeout(() => {
                                        if (containerRef.current) {
                                            const rect = containerRef.current.getBoundingClientRect();
                                            if (rect.top < 0 || rect.bottom > window.innerHeight) {
                                                containerRef.current.scrollIntoView({
                                                    behavior: 'smooth',
                                                    block: 'start'
                                                });
                                            }
                                        }
                                    }, 100);
                                }, true);
                            }
                        }, 500);

                    } catch (error) {
                    }
                }
            }, 200);
        };

        // Only add script if not already present
        if (!document.querySelector('script[src*="embed_jobs.js"]')) {
            document.body.appendChild(script);
        } else if (window.rec_embed_js && !isInitialized.current) {
            // Script already loaded, just initialize
            setTimeout(() => {
                try {
                    window.rec_embed_js.load({
                        widget_id: "rec_job_listing_div",
                        page_name: "Career4",
                        source: "CareerSite",
                        site: "https://career.coschool.ai",
                        brand_color: "#6875E2",
                        empty_job_msg: "No current Openings"
                    });
                    isInitialized.current = true;
                } catch (error) {
                }
            }, 200);
        }

        return () => {
            // Clean up event listeners but keep scripts for reuse
            const jobsDiv = document.getElementById('rec_job_listing_div');
            if (jobsDiv) {
                jobsDiv.innerHTML = '';
            }
        };
    }, []);

    return (
        <div
            ref={containerRef}
            style={{
                minHeight: '400px',
                width: '100%',
                position: 'relative',
                overflow: 'visible'
            }}
        >
            <div className="embed_jobs_head embed_jobs_with_style_3">
                <div className="embed_jobs_head2">
                    <div className="embed_jobs_head3">
                        <div id="rec_job_listing_div"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZohoWidget;